import { useCallback, useEffect, useState } from 'react'

export default function useTimer() {

  const [curTime, setCurTime] = useState('');
  const [curDate, setCurDate] = useState('');

  const [withSeconds, setWithSeconds] = useState(false);
  const [withYear, setWithYear] = useState(false);

  const paddy = (num) => {
    return (""+num).padStart(2,'0');
  }

  const flipSecondsMode = () => {
    setWithSeconds(!withSeconds);
  }

  const flipYearMode = () => {
    setWithYear(!withYear);
  }

  const getDateTimeDisplay = useCallback(() => {
    const now = new Date();
    const sec = withSeconds ? `:${paddy(now.getSeconds())}` : '';

    const timeDisplay = `${paddy(now.getHours())}:${paddy(now.getMinutes())}${sec}`;    
    const dateDisplay = now.toLocaleDateString('en-US', {month: withYear ? 'long':'short', day:'2-digit', year: withYear ? 'numeric' : '2-digit', weekday: withYear?'long':'short'});
    
    return { timeDisplay, dateDisplay };
  }, [withSeconds, withYear]);

  useEffect(()=> {
    const t = setInterval(() => {
      const {timeDisplay, dateDisplay} = getDateTimeDisplay();
      setCurTime(timeDisplay);
      setCurDate(dateDisplay);
    }, withSeconds ? 1000 : 10000);

    const {timeDisplay, dateDisplay} = getDateTimeDisplay();
    setCurTime(timeDisplay);
    setCurDate(dateDisplay);

    return () => {clearInterval(t)}
  }, [withSeconds, withYear, getDateTimeDisplay]);

  return {
    curTime, curDate, flipSecondsMode, flipYearMode
  }
}
